<!--- Top content-blocks (headers) ------------------------------>

<app-video-header *ngIf="videoHeader"
                  [video]="videoHeader.video.video"
                  [layout]="videoHeader.headerLayout"
></app-video-header>

<app-image-header *ngIf="imageHeader"
                  [images]="imageHeader.images"
                  [title]="imageHeader.title"
                  [subtitle]="imageHeader.subtitle"
                  [layout]="imageHeader.headerLayout"
                  [lazyLoad]="firstComponentOfPage !== imageHeader.__typename"
></app-image-header>

<app-image-text-header *ngIf="imageTextHeader"
                       [title]="imageTextHeader.title"
                       [subtitle]="imageTextHeader.subtitle ?? null"
                       [description]="imageTextHeader.description ?? null"
                       [brandImage]="imageTextHeader.smallImage ?? null"
                       [headerImage]="imageTextHeader.mainImage ?? null"
                       [lazyLoad]="firstComponentOfPage !== imageTextHeader.__typename"
></app-image-text-header>

<app-text-header *ngIf="textHeader"
                 [firstLine]="textHeader.firstLine"
                 [secondLine]="textHeader.secondLine"
></app-text-header>

<!--- Mid content-blocks (midpage) ------------------------------>

<app-project-showcase *ngIf="projectShowcases"
                      [preHeading]="projectShowcases.subtitle"
                      [title]="projectShowcases.title"
                      [text]="projectShowcases.description"
                      [link]="projectShowcases.link"
                      [projectsSlides]="projectShowcaseSlides"
                      [lazyLoad]="firstComponentOfPage !== projectShowcases.__typename"
></app-project-showcase>

<app-pages-links *ngIf="pageLinks"
                 [pageLinks]="pageLinks"
></app-pages-links>

<app-accordion *ngIf="accordion"
               [accordion]="accordion"
></app-accordion>

<app-paragraphs *ngIf="paragraphs"
                [paragraphs]="paragraphs"
></app-paragraphs>

<app-grid *ngIf="paragraphCarousel">
    <app-cell mobile="0:12">
        <app-paragraph-carousel [paragraphCarousels]="paragraphCarousel"
        ></app-paragraph-carousel>
    </app-cell>
</app-grid>

<app-quotes *ngIf="quotes"
            [quotes]="quotes"
></app-quotes>

<app-grid *ngIf="stats" [gap]="true">
    <app-cell *ngFor="let stat of stats.statistics; let i = index"
              mobile="0:12"
              [tablet]="i % 2 ? '6:9' : '3:6'">
        <app-stats [label]="stat.value"
                   [value]="stat.label"
                   [layout]="stats.statisticsLayout"
        ></app-stats>
    </app-cell>
</app-grid>

<app-usps *ngIf="uniqueSellingPoints"
          [usps]="uniqueSellingPoints"
></app-usps>

<app-grid *ngIf="map">
    <app-cell mobile="full:full">
        <app-google-maps [cmsMarkers]="map.markers"
        ></app-google-maps>
    </app-cell>
</app-grid>

<app-news-letter *ngIf="newsLetter"
                 [newsLetter]="newsLetter"
></app-news-letter>

<app-image-mosaic *ngIf="imageMosaic"
                  [landscape1]="imageMosaic.landscape1"
                  [landscape2]="imageMosaic.landscape2"
                  [portrait]="imageMosaic.portrait"
                  [lazyLoad]="firstComponentOfPage !== imageMosaic.__typename"
></app-image-mosaic>

<app-image-with-text *ngIf="imageWithText"
                     [header]="imageWithText.title"
                     [preHeader]="imageWithText.subtitle"
                     [content]="imageWithText.content"
                     [image]="imageWithText.image"
                     [buttons]="imageWithText.buttons"
                     [lazyLoad]="firstComponentOfPage !== imageWithText.__typename"
                     [transparentBackground]="! imageWithText.showGrayBack"
                     [textAlign]="imageWithText.imageLayout === ImagePositionEnum.Left ? 'right' : 'left'"
></app-image-with-text>

<app-video-with-text *ngIf="videoWithText"
                     [header]="videoWithText.title"
                     [preHeader]="videoWithText.subtitle"
                     [content]="videoWithText.content"
                     [video]="videoWithText.videoText"
></app-video-with-text>

<app-image-content *ngIf="imageText"
                   [image]="imageText.image"
                   [caption]="imageText.title"
                   [lazyLoad]="firstComponentOfPage !== imageText.__typename"
></app-image-content>

<app-video-content *ngIf="videoText"
                   [video]="videoText.video"
                   [caption]="videoText.title"
></app-video-content>

<app-carousel *ngIf="carousel"
              [theme]="carousel.theme"
              [slides]="carousel.slides"
              [title]="carousel.title"
              [subtitle]="carousel.subtitle"
              [showHeader]="carousel.showHeader"
              [showScrollBar]="carousel.showScrollBar"
              [lazyLoad]="firstComponentOfPage !== carousel.__typename"
></app-carousel>

<app-assets *ngIf="assets"
            [assets]="assets"
></app-assets>

<app-contact-form *ngIf="isContactForm"
></app-contact-form>

<app-data-request-form *ngIf="isDataRequestForm"
></app-data-request-form>

<app-image-content-link *ngIf="imageContentLink"
                       [data]="imageContentLink"
                       [lazyLoad]="firstComponentOfPage !== imageContentLink.__typename"
                       [transparentBackground]="! imageContentLink.showGrayBack"
></app-image-content-link>

<app-cta-link-content *ngIf="ctaLink"
                      [header]="ctaLink.title"
                      [preHeader]="ctaLink.subtitleCta"
                      [text]="ctaLink.textCta"
                      [image]="ctaLink.image"
                      [button]="ctaLink.button"
                      [lazyLoad]="firstComponentOfPage !== ctaLink.__typename"
></app-cta-link-content>

<app-product-categories *ngIf="categories"
                        [categories]="categories.categories"
                        [sale]="categories.sale"
                        [new]="categories.new"
                        [title]="categories.title"
                        [subtitle]="categories.subtitle"
                        [lazyLoad]="firstComponentOfPage !== categories.__typename"
></app-product-categories>

<!--- End content-blocks (sticked to footer) ------------------------------>

<app-subfooter-links *ngIf="subFooterLink"
                     [subfooterLinks]="subFooterLink"
></app-subfooter-links>

<app-subfooter-account-manager *ngIf="accountManager?.show"
></app-subfooter-account-manager>
